<div class="modal" [class.active]="isOpen">

  <!-- OVERLAY -->
  <a class="modal-overlay" aria-label="Close" (click)="onClose.emit()"></a>

  <!-- CONTAINER -->
  <div class="modal-container">

    <!-- HEADER -->
    <div class="modal-header">
      <a class="float-right" aria-label="Close" (click)="onClose.emit()">
        <material-icon>close</material-icon>
      </a>
      <div class="modal-title h5">{{ title | translate }}</div>
    </div>

    <!-- BODY -->
    <div class="modal-body">
      <div class="content">
        <ng-content select="[modal-body]"></ng-content>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="modal-footer">
      <ng-content select="[modal-footer]"></ng-content>
    </div>

  </div>

</div>
